import { useState } from "react";
import { useDispatch } from "react-redux";

import { bulkChangeRoleCompanyEventRequestsRequest } from "../../../../../../store/CompanyPortal/EventRequests/actions";

const useChangeRole = ({
  listParams,
  selectedApplicants,
  setSelectedIds,
  setSelectedRowsById,
}) => {
  const dispatch = useDispatch();
  const [targetApplicants, setTargetApplicants] = useState([]);

  const closeChangeRoleModal = () => {
    setTargetApplicants([]);
  };

  const openBulkChangeRoleModal = () => {
    setTargetApplicants(selectedApplicants);
  };

  const confirmChangeRole = ({ role, shift }) => {
    dispatch(
      bulkChangeRoleCompanyEventRequestsRequest({
        eventRequestIds: targetApplicants.map((applicant) => applicant.id),
        roleId: role?.id,
        eventRoleShiftId: shift?.id,
        listParams,
        onSuccess: () => {
          setSelectedIds([]);
          setSelectedRowsById({});
          closeChangeRoleModal();
        },
      }),
    );
  };

  return {
    changeRoleApplicants: targetApplicants,
    closeChangeRoleModal,
    confirmChangeRole,
    isChangeRoleModalOpen: targetApplicants.length > 0,
    openBulkChangeRoleModal,
  };
};

export default useChangeRole;
